/**
 * Auth-aware fetch: sends credentials (cookies) so the backend CookieTokenAuthentication
 * can read the token cookie. Use for all API calls that may require auth.
 */
export function useAuthFetch() {
  /**
   * Fetch with credentials so the token cookie is sent; backend reads request.COOKIES.get('token').
   */
  async function authFetch<T = unknown>(
    url: string,
    options: Record<string, unknown> & {
      headers?: Record<string, string>;
      params?: Record<string, string | number>;
    } = {},
  ): Promise<T> {
    const { headers: optHeaders, ...rest } = options;
    const headers: Record<string, string> = {
      Accept: "application/json",
      "Content-Type": "application/json",
      ...(optHeaders as Record<string, string>),
    };
    return $fetch<T>(url, {
      ...rest,
      credentials: "include",
      headers,
    });
  }

  return { authFetch };
}
